export default {
    apiKey: "AIzaSyAAn97VwrsDgU53qunwSezGZ1YjynHMLVw",
    authDomain: "ares-uat3-app.firebaseapp.com",
    projectId: "ares-uat3-app",
    storageBucket: "ares-uat3-app.appspot.com",
    messagingSenderId: "632291492703",
    appId: "1:632291492703:web:32ad3d2fcb6f4ae6be2cea",
    measurementId: "G-W3DCQZ777Y"
};